import axios from 'axios';

/**
 * Axios instance
 */
const axiosInstance = axios.create();


/**
 * Call To Server Method
 * A wrapper to all of application requests
 *
 * @param {string} method The request method
 * @param {string} endpoint The endpoint of the request
 * @param {Object} payload If you want to post some data
 */
const cts = async (method = 'get', endpoint, payload = {}, options = {}) => {
  try {
    const { data, status } = await axiosInstance[method](endpoint, payload, options);
    if (status !== 200 || !data) {
      throw new Error('Unable to complete the request!');
    }
    return { data, error: null };
  } catch (ERROR) {
    // TODO: Handle Error
    if (process.env.NODE_ENV !== 'production') {
      console.log(
        `${ERROR} \nEndpoint: ${endpoint}\nPayload: ${JSON.stringify(payload)}`
      );
    }
    return { data: null, error: ERROR };
  }
};

export {
  axiosInstance
};

export default cts;
